import { JobOrderApplicationProcessStatusEnum as DtoEnum } from 'types/api.types.generated.d';

export enum JobOrderApplicationProcessStatusEnum {
  Created = 'Created',
  Applied = 'Applied',
  ScheduledForCQ = 'ScheduledForCQ',
  AcceptedAfterCQ = 'AcceptedAfterCQ',
  RejectedAfterApplied = 'RejectedAfterApplied',
  RejectedAfterCQ = 'RejectedAfterCQ',
  NotSent = 'NotSent',
  Sent = 'Sent',
  MeetingsScheduled = 'MeetingsScheduled',
  MeetingsCancelled = 'MeetingsCancelled',
  CICancelledByExpert = 'CICancelledByExpert',
  CICancelledByClient = 'CICancelledByClient',
  CIScheduled = 'CIScheduled',
  CIFinished = 'CIFinished',
  Accepted = 'Accepted',
  Rejected = 'Rejected',
  RejectedAfterCI = 'RejectedAfterCI',
  RejectedOffer = 'RejectedOffer',
  NoFeedback = 'NoFeedback',
  ExpertWithdrew = 'ExpertWithdrew',
  ClientWithdrew = 'ClientWithdrew',
  Placement = 'Placement',
  CIScheduledSecondStage = 'CIScheduledSecondStage',
  CIFinishedSecondStage = 'CIFinishedSecondStage',
  CIScheduledThirdStage = 'CIScheduledThirdStage',
  CIFinishedThirdStage = 'CIFinishedThirdStage',
  RejectedBySales = 'RejectedBySales',
  OfferExpired = 'OfferExpired',
  RejectedByExpert = 'RejectedByExpert',
}

export const endedApplicationProcessStatuses = [
  JobOrderApplicationProcessStatusEnum.Rejected,
  JobOrderApplicationProcessStatusEnum.RejectedAfterCQ,
  JobOrderApplicationProcessStatusEnum.RejectedAfterApplied,
  JobOrderApplicationProcessStatusEnum.RejectedBySales,
  JobOrderApplicationProcessStatusEnum.NoFeedback,
  JobOrderApplicationProcessStatusEnum.CICancelledByClient,
  JobOrderApplicationProcessStatusEnum.CICancelledByExpert,
  JobOrderApplicationProcessStatusEnum.RejectedAfterCI,
  JobOrderApplicationProcessStatusEnum.ExpertWithdrew,
  JobOrderApplicationProcessStatusEnum.ClientWithdrew,
  JobOrderApplicationProcessStatusEnum.RejectedOffer,
  JobOrderApplicationProcessStatusEnum.RejectedByExpert,
  JobOrderApplicationProcessStatusEnum.OfferExpired,
];

export const contactedApplicationProcessStatuses = [JobOrderApplicationProcessStatusEnum.Placement];

export const activeApplicationProcessStatuses = Object.values(
  JobOrderApplicationProcessStatusEnum,
).filter(
  (status) =>
    !endedApplicationProcessStatuses.includes(status) &&
    !contactedApplicationProcessStatuses.includes(status),
);

export const mapDtoToEnum = (dtoStatus: DtoEnum): JobOrderApplicationProcessStatusEnum => {
  switch (dtoStatus) {
    case DtoEnum.Created:
      return JobOrderApplicationProcessStatusEnum.Created;
    case DtoEnum.Accepted:
      return JobOrderApplicationProcessStatusEnum.Accepted;
    case DtoEnum.AcceptedAfterCq:
      return JobOrderApplicationProcessStatusEnum.AcceptedAfterCQ;
    case DtoEnum.Applied:
      return JobOrderApplicationProcessStatusEnum.Applied;
    case DtoEnum.CiCancelledByClient:
      return JobOrderApplicationProcessStatusEnum.CICancelledByClient;
    case DtoEnum.CiCancelledByExpert:
      return JobOrderApplicationProcessStatusEnum.CICancelledByExpert;
    case DtoEnum.CiFinished:
      return JobOrderApplicationProcessStatusEnum.CIFinished;
    case DtoEnum.CiFinishedSecondStage:
      return JobOrderApplicationProcessStatusEnum.CIFinishedSecondStage;
    case DtoEnum.CiFinishedThirdStage:
      return JobOrderApplicationProcessStatusEnum.CIFinishedThirdStage;
    case DtoEnum.CiScheduled:
      return JobOrderApplicationProcessStatusEnum.CIScheduled;
    case DtoEnum.CiScheduledSecondStage:
      return JobOrderApplicationProcessStatusEnum.CIScheduledSecondStage;
    case DtoEnum.CiScheduledThirdStage:
      return JobOrderApplicationProcessStatusEnum.CIScheduledThirdStage;
    case DtoEnum.ClientWithdrew:
      return JobOrderApplicationProcessStatusEnum.ClientWithdrew;
    case DtoEnum.ExpertWithdrew:
      return JobOrderApplicationProcessStatusEnum.ExpertWithdrew;
    case DtoEnum.MeetingsCancelled:
      return JobOrderApplicationProcessStatusEnum.MeetingsCancelled;
    case DtoEnum.MeetingsScheduled:
      return JobOrderApplicationProcessStatusEnum.MeetingsScheduled;
    case DtoEnum.NoFeedback:
      return JobOrderApplicationProcessStatusEnum.NoFeedback;
    case DtoEnum.NotSent:
      return JobOrderApplicationProcessStatusEnum.NotSent;
    case DtoEnum.OfferExpired:
      return JobOrderApplicationProcessStatusEnum.OfferExpired;
    case DtoEnum.Placement:
      return JobOrderApplicationProcessStatusEnum.Placement;
    case DtoEnum.Rejected:
      return JobOrderApplicationProcessStatusEnum.Rejected;
    case DtoEnum.RejectedAfterApplied:
      return JobOrderApplicationProcessStatusEnum.RejectedAfterApplied;
    case DtoEnum.RejectedAfterCi:
      return JobOrderApplicationProcessStatusEnum.RejectedAfterCI;
    case DtoEnum.RejectedAfterCq:
      return JobOrderApplicationProcessStatusEnum.RejectedAfterCQ;
    case DtoEnum.RejectedByExpert:
      return JobOrderApplicationProcessStatusEnum.RejectedByExpert;
    case DtoEnum.RejectedBySales:
      return JobOrderApplicationProcessStatusEnum.RejectedBySales;
    case DtoEnum.RejectedOffer:
      return JobOrderApplicationProcessStatusEnum.RejectedOffer;
    case DtoEnum.ScheduledForCq:
      return JobOrderApplicationProcessStatusEnum.ScheduledForCQ;
    case DtoEnum.Sent:
      return JobOrderApplicationProcessStatusEnum.Sent;
    default:
      throw new Error(`Unhandled status: ${dtoStatus}`);
  }
};
